import React from 'react';
import './rankingMatrixItem.scss';
import check from '../../../../../assets/check.svg';

const RankingMatrixItem = (props) => {
    const {
        id,
        prompt,
        promptId,
        answerStatement,
        handleSelect,
        selectedAnswers
    } = props;

    const determineInputValues = (max, min=1) => {
        const values = [];

        let current = max;
        while (current >= min) {
            values.push(current);
            current--;
        }

        return values;
    }

    const isChecked = (inputValue) => {
        const selectedVal = selectedAnswers[id];

        if (selectedVal !== null && inputValue === selectedVal) {
            return true;
        }

        return false;
    }

    let inputRows;
    let headers;
    if (prompt.typeOptions) {
        const inputValues = determineInputValues(prompt.typeOptions.maxValue, prompt.typeOptions.minValue);
        const columnDescriptions = prompt.typeOptions.columnDescriptions;

        inputRows = inputValues.map((value) => {
            return (
                <label className="radio-container">
                    <input className="radio-button" checked={isChecked(value)} type="radio" value={value} name={`${promptId}-${id}`}/> <span><img className="check icon" src={check} alt=""/></span>
                </label>
            )
        });

        headers = columnDescriptions.filter((el) => el).map((description, idx) => {
            return (
                <div className="header-item">{description}</div>
            )
        })
    }

    return (
        <div className="row-container" id={id} onChange={(e) => handleSelect(e, answerStatement)}>
            <h3 className="row-statement">{answerStatement}</h3>
            <div className="input-rows-container">
                <div className="description-labels m">{headers}</div>
                <div className="input-rows">{inputRows}</div>
            </div>
        </div>
    );
};

export default RankingMatrixItem;